/**
 * Shared utility for sanitizing markdown content to remove file:// URIs
 * This prevents local file paths from being rendered or linked in markdown content
 */

/**
 * Sanitizes markdown content by removing or replacing file:// URIs
 * @param {string} content - The markdown content to sanitize
 * @returns {string} - Sanitized markdown content
 */
export const sanitizeMarkdown = (content) => {
  if (!content || typeof content !== 'string') return content || '';

  let sanitized = content;

  // Remove markdown images that point to file://
  sanitized = sanitized.replace(/!\[[^\]]*\]\(\s*file:\/\/[^)]+\)/gi, '[image removed]');

  // Replace markdown links pointing to file:// with just their label
  sanitized = sanitized.replace(/\[([^\]]+)\]\(\s*file:\/\/[^)]+\)/gi, '$1');

  return sanitized;
};
